import { TGameListItem } from '@/apis/hub88';
import { gameListSelector } from '@/state/globalSettings';
import { useAtom } from 'jotai';

/**
 * use game id or game slug to find the matching game from gamelist state
 * also see: apps/web/utils/biz/mapFavoriteOrRecentToLocal.ts:11,43 when updating this hooks
 */
const useFindMatchingGame = (
  gameIdOrSlug: string | number,
): TGameListItem | undefined => {
  const [{ list }] = useAtom(gameListSelector);

  const stringifiyedGameId = String(gameIdOrSlug).toLowerCase();

  const matchingGame = list.find(
    (game) =>
      game.slug.toLowerCase() === stringifiyedGameId ||
      game.gameId.toLowerCase() === stringifiyedGameId,
  );

  return matchingGame;
};

export default useFindMatchingGame;
